<template>
  <el-form ref="form" :model="form" class="form_flex">
    <el-form-item prop="status">
      <el-select
        class="search-select"
        v-model="form.status"
        placeholder="请选择状态"
        @change="changeRole"
      >
        <el-option
          v-for="(item, index) in rolesList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item prop="title">
      <el-input
        v-model="form.title"
        autocomplete="off"
        class="msg-input"
        placeholder="请输入标题"
      />
    </el-form-item>

    <el-form-item class="btn">
      <el-button
        @click="$emit('search', { ...form })"
        icon="el-icon-search"
        size="small"
        >查询</el-button
      >
      <el-button size="small" icon="el-icon-plus" @click="resetForm"
        >清空</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
      <el-button
        size="small"
        icon="el-icon-plus"
        @click="$emit('openAddForm')"
        type="primary"
        v-if="roleList[path].includes('_Add')"
        >新增</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';
// import { sendMyMsgApi } from '@/api/newsApi.js'
export default {
  name: 'MessageSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      // 表单内容
      form: {
        status: '',
        title: '',
      },
      roleName: '',
      rolesList: [
        { label: '编辑中', value: 1 },
        { label: '已发布', value: 2 },
        { label: '已删除', value: 3 },
      ],
      loading: false,
      path: '',
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    // 点击状态下拉数据
    changeRole(val) {
      this.form.status = val;
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm() {
      this.$refs['form'].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-select {
  width: 120px;
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

.msg-input {
  width: 330px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
